export const hasInjectedContent = (element: HTMLElement): boolean => {
	const hasChildren = element.childElementCount > 0
	const hasText = !!element.textContent?.trim()

	return hasChildren || hasText
}
